<button
  (click)="trigger()"
  class="button button--{{ size }}"
  [ngClass]="{ 'button--filled': filled, 'button--disabled': disabled }"
  [disabled]="disabled"
>
  <ng-content></ng-content>
</button>
